import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { setTabId } from 'reducers/partnerFormReducer';
import { routeList } from 'Routes';
import { PartnerFormTabItems } from 'views/PartnerTabs/PrivateIndividualFormTabs';
import { ClmPortalIncomingPostMessageTypes } from 'utils/postMessageUtil';
import { useHost } from 'contexts/Host';
import { requestHostNavigation } from 'utils/browserUtil';

/**
 * Component for handling the shared messages between the partner tab contexts
 */
const PartnerTabsMessageHandler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isTabValid = (tab: string) => Object.values(PartnerFormTabItems).includes(tab as PartnerFormTabItems);
  const { isWena } = useHost();
  useEffect(() => {
    window.addEventListener('message', handleMessage);

    async function handleMessage(event: any) {
      const message = event.data.message;
      const value = event.data.value;

      switch (message) {
        case ClmPortalIncomingPostMessageTypes.SEE_PARTNER_LIST: {
          navigate('/partners');

          break;
        }
        case ClmPortalIncomingPostMessageTypes.NEW_TAB_BR_PARTNER_RELATIONS: {
          const { brId } = value;
          window.open(`/business-relation/edit/${brId}/br-relations`);
          break;
        }
        case ClmPortalIncomingPostMessageTypes.REDIRECT_TO_PARTNER: {
          const path = `/partner/edit/${value.partnerUid}/core-data?wizardBrUid=${value.wizardBrUid ?? ''}&wizardRole=${value.wizardRole ?? ''}`;
          if (isWena) {
            requestHostNavigation(path);
            break;
          }
          window.open(path);
          break;
        }
        case ClmPortalIncomingPostMessageTypes.NEW_TAB_BR_CORE_DATA: {
          const { brId, brSource } = value;
          const path = `${routeList.brCoreData(brId)}${brSource === 'CRM_CH_BR' ? '?brSource=CRM' : ''}`;

          if (isWena) {
            requestHostNavigation(path);
            break;
          }
          window.open(path);

          break;
        }
        case ClmPortalIncomingPostMessageTypes.NEW_TAB_CREATE_CLIPP_PRICING: {
          const { clippPricingCreateUrl } = value;
          window.open(clippPricingCreateUrl);

          break;
        }
        case ClmPortalIncomingPostMessageTypes.NEW_TAB_OPEN_DOCUMENT: {
          const { documentBlob } = value;
          const url = URL.createObjectURL(documentBlob);
          const pdfWindow = window.open();
          if (pdfWindow) {
            pdfWindow.location.href = url;
          }

          break;
        }
        case ClmPortalIncomingPostMessageTypes.OPEN_PARTNER_TAB: {
          const { tab } = value;
          window.open(`/partner/edit/${value.partnerUid}/${isTabValid(tab) ? tab : PartnerFormTabItems.CORE_DATA}`);
          break;
        }
        case ClmPortalIncomingPostMessageTypes.CHANGE_TAB_NO_CONFIRMATION: {
          const { tab } = value;
          isTabValid(tab) && dispatch(setTabId(tab));
          break;
        }
      }
      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  }, []);

  return null;
};

export default PartnerTabsMessageHandler;
